import {
  displayNotification,
  INotification,
  NotificationDurationMs,
  NotificationType,
  useAppDispatch,
  useTranslation,
} from "@next-platform/client-common-core";
import { useCallback } from "react";

import { getDefaultNotificationMessage } from "@/components/common/Notification/utils/notification";

type DisplayToastOptions = {
  message?: string;
  title?: string;
  type?: NotificationType;
};

const createNotification = ({ message, title, type }: { message: string; title?: string; type: NotificationType }): INotification => ({
  duration: NotificationDurationMs.normal,
  message,
  title,
  type,
});

const useToast = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const displayToast = useCallback(
    ({ message, title, type = NotificationType.default }: DisplayToastOptions) => {
      const notificationMessage = message || getDefaultNotificationMessage({ type, t });

      dispatch(displayNotification(createNotification({ message: notificationMessage, title, type })));
    },
    [dispatch, t],
  );

  return { displayToast };
};

export default useToast;
